<login-header></login-header>

<div class="affiliate-top">
    <div class="content-width text-center">
        <div class="affiliate-top-content">
            <h1 class="heading3">Become a Family Central affiliate</h1>
            <h2 class="heading1">Earn $5 per subscriber, per month <span>– in perpetuity, for as long as they stay subscribed</span></h2>
        </div>
    </div>
</div>

<div class="affiliate-hero" style="background-image: url('/assets/images/affiliate-hero.webp');">
    <div class="content-width">
        <div class="affiliate-content">
            <h3>Unlimited Passive Income Opportunities</h3>

            <div class="opportunities-list d-flex">
                <div class="opportunities d-flex mbl-column">
                    <div class="opportunities-image">
                        <img src="/assets/images/easy-conversions.svg" alt="">
                    </div>
                    <div class="opportunities-text">
                        <h4>Easy conversions </h4>
                        <p>Free 30-day trials (no credit card needed).</p>
                        <p>Family Central is secure.</p>
                        <ul>
                            <li>Secure personal file vault</li>
                            <li>Calendars & To-do lists</li>
                            <li>GPS tracking</li>
                            <li>Legacy video messages</li>
                            <li>Emergency planning</li>
                            <li>24/7 phone/chat support.</li>
                        </ul>
                        <p>Click to learn more about <a routerLink="/underconstruction">the Family Central App</a></p>
                    </div>
                </div>
                <div class="opportunities d-flex mbl-column">
                    <div class="opportunities-image">
                        <img src="/assets/images/Earn-as-we-grow-icon.svg" alt="">
                    </div>
                    <div class="opportunities-text">
                        <h4>Unlimited earnings</h4>
                        <p>20% commission (currently equivalent to $5.99 for each month your subscriber stays with the program.</p>
                        <p>We keep paying every month, FOR THE LIFE OF THE SUBSCRIPTION.</p>
                    </div>
                </div>
                <div class="opportunities d-flex mbl-column">
                    <div class="opportunities-image">
                        <img src="/assets/images/marketing-dashboard.svg" alt="">
                    </div>
                    <div class="opportunities-text">
                        <h4>Marketing Dashboard</h4>
                        <p>Our industry-leading affiliate platform partner is Impact.com.</p>
                        <p>Read about Impact here: <a routerLink="/underconstruction">(<span>Impact Platform pdf.</span>)</a></p>
                    </div>
                </div>
            </div>

            <div class="opportunities-cta text-end">
                <button type="button" class="primary_btn medium-blue" routerLink="/underconstruction">Read How Our Affiliate Program Works</button>
            </div>
        </div>
    </div>
</div>

<app-footer (showPrice)="showPricing()"></app-footer>

<ng-template #pricing>
    <app-pricing (onCancel)="onClose()"></app-pricing>
</ng-template>